/* eslint-disable no-param-reassign */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { Highlight, Snippet } from 'react-instantsearch-dom';
import { Hit } from '../Hits';

export const PageHit = ({ hit }) => {
  return (
    <Hit
      slug={hit.slug}
      title={<Highlight attribute="title" hit={hit} tagName="mark" />}
      details={<Snippet attribute="excerpt" hit={hit} tagName="mark" />}
    />
  );
};
